import React, { useState, useEffect, useRef } from 'react';
/* eslint-disable */
import * as Yup from 'yup';

// material
import { Container } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Stack,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Typography,
  Checkbox,
  Card,
  Box,
  InputAdornment
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { trackPromise } from 'react-promise-tracker';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import _ from 'lodash';
import { LoadingComponent } from 'src/pages/pageLoader';
import { CustomMaterialTable } from '../../Common/CustomMaterialTable';
import TableContainer from '@material-ui/core/TableContainer';
import SearchNotFound from '../../../SearchNotFound';
import LoadingButton from '@mui/lab/LoadingButton';
import CreatePDF from './CreatePDF';
import ReactToPrint from 'react-to-print';
import xlsx from 'json-as-xlsx';
import { makeStyles } from '@material-ui/styles';
import Search from '@mui/icons-material/Search';
import LineWeightIcon from '@material-ui/icons/LineWeight';
import { CustomTable } from './CustomTable';

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

var screenCode = 'ORDERVIEW';

export default function ViewOrder(props) {
  const classes = useStyles();
  const componentRef = useRef();
  const [group, setGroup] = useState([]);
  const [factory, setFactory] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [headCells, setHeadCells] = useState([]);
  const [outletOrderDetails, setOutletOrderDetails] = useState([]);
  const [outletOrderDetailsOne, setOutletOrderDetailsOne] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabled2, setIsDisabled2] = useState([]);
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [isEnable, setIsEnable] = useState(true);

  const handleChecked = (event) => {
    setChecked(event.target.checked);
  };
  let encrypted = '';
  const navigate = useNavigate();
  const [date, setDate] = useState(new Date());
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: 0,
    date: ''
  });

  const [outletData, setOutletData] = useState({
    productCode: ''
  });

  const [totalValues, setTotalValues] = useState({
    totalFullfilled: 0,
    totalQtyKG: 0,
    totalQtyUnit: 0,
    remainingQty: 0,
    fulfilledSumKg: 0,
    fulfilledSumUnit: 0,
    remainingKG: 0,
    remainingUnit: 0,
    shortSupplyAmount: 0
  });

  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: '',
    date: ''
  });

  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    operationEntityID: Yup.number().notRequired(),
    date: Yup.date().notRequired()
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      date: formData.date
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm(values));
    }
  });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWORDER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
    });
    trackPromise(GetAllGroups());
  }

  useEffect(() => {
    trackPromise(GetFactoriesByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    setTableData([]);
    setOutletData({
      ...outletData,
      productCode: ''
    });
  }, [date]);

  useEffect(() => {
    handleSearch(outletData.productCode);
  }, [outletData.productCode]);

  useEffect(() => {
    if (tableData.length != 0) {
      calculateTotalQty();
    }
  }, [tableData]);

  async function GetAllGroups() {
    var res = await services.GetAllGroups();
    if (res != null) {
      setGroup(res);
    }
  }

  async function GetFactoriesByGroupID() {
    var res = await services.GetFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setFactory(res);
    }
  }

  async function SubmitForm(value) {
    setOutletData({
      ...outletData,
      productCode: ''
    });
    setTableData([]);
    var date1 = date.toISOString().split('T')[0];
    var date2 = date1.split('-');
    var date3 = date2[0] + date2[1] + date2[2];

    var result = await services.GetOutletOrderDetails(date.toISOString());
    let res = result.detailsOne;
    let resOne = result.detailsTwo;

    var ress = await services.GetAllProductsDetails();
    getPerformOrderDetailsForMainOrder();
    setOutletOrderDetails(res);
    setOutletOrderDetailsOne(resOne);

    let newRes = _.cloneDeep(res);

    let newRess = _.cloneDeep(ress);
    newRes.forEach((x) => {
      var product = newRess.find((z) => z.productCode == x.productCode);
      x.proName = product == undefined ? '-' : product.productName;
    });
    newRes.sort((a, b) => (a.proName > b.proName ? 1 : -1));
    const headCells = [
      {
        id: 'productCode',
        numeric: false,
        headCellAlign: 2,
        tableCellAlign: 2,
        disablePadding: false,
        label: 'SKU'
      },
      {
        id: 'proName',
        numeric: false,
        headCellAlign: 2,
        tableCellAlign: 2,
        disablePadding: false,
        label: 'Crop Name'
      },
      {
        id: 'quantity',
        numeric: true,
        headCellAlign: 3,
        tableCellAlign: 3,
        disablePadding: false,
        label: 'Quantity'
      },
      {
        id: 'fulfilledQuantity',
        numeric: true,
        headCellAlign: 3,
        tableCellAlign: 3,
        disablePadding: false,
        label: 'Fulfilled Quantity'
      },
      {
        id: 'measuringUnitName',
        numeric: false,
        headCellAlign: 3,
        tableCellAlign: 3,
        disablePadding: false,
        label: 'Measuring Unit'
      }
    ];
    if (newRes.length != 0) {
      setIsEnable(false);
    }
    newRes.forEach((x) => {
      if (x.measuringUnit == 1) {
        x.measuringUnitName = x.measuringGram == 0 ? 'Unit' : 'Unit ' + x.measuringGram + 'G';
      } else if (x.measuringUnit == 2) {
        x.measuringUnitName = 'KG';
      } else if (x.measuringUnit == 3) {
        x.measuringUnitName = 'G';
      } else {
        x.measuringUnitName = '';
      }
    });
    setHeadCells(headCells);
    setTableData(newRes);
    setTableData1(newRes);
    getSelectedDropdownValuesForReport();
  }

  function calculateTotalQty() {
    const totalKG = tableData
      .filter((item) => item.measuringUnit === 2)
      .reduce((accumulator, current) => accumulator + current.quantity, 0);
    const totalUnit = tableData
      .filter((item) => item.measuringUnit === 1)
      .reduce((accumulator, current) => accumulator + current.quantity, 0);
    const sum = tableData.reduce((accumulator, current) => accumulator + current.quantity, 0);
    const fulfilledSumKg = tableData
      .filter((item) => item.measuringUnit === 2)
      .reduce((accumulator, current) => accumulator + current.fulfilledQuantity, 0);
    const fulfilledSumUnit = tableData
      .filter((item) => item.measuringUnit === 1)
      .reduce((accumulator, current) => accumulator + current.fulfilledQuantity, 0);
    const remainingKG = totalKG - fulfilledSumKg;
    const remainingUnit = totalUnit - fulfilledSumUnit;
    setTotalValues({
      ...totalValues,
      totalQtyKG: totalKG,
      totalQtyUnit: totalUnit,
      fulfilledSumKg: fulfilledSumKg,
      fulfilledSumUnit: fulfilledSumUnit,
      remainingKG: remainingKG,
      remainingUnit: remainingUnit
    });
  }

  async function generatePerformOrder() {
    let newOutletOrder = _.cloneDeep(outletOrderDetailsOne);

    var res = await services.GetAllConfigarationValues(
      formik.values.groupID,
      formik.values.operationEntityID
    );
    var ress = await services.GetApprovedProductPrice(date.toISOString());
    let productPrice = _.cloneDeep(ress);
    var productPriceResult = approvedProductPriceSort(productPrice);
    let model = {
      date: date.toISOString(),
      productPrice: productPriceResult,
      outletOrder: [],
      newOutletOrder: newOutletOrder
    };
    var res = await services.SaveGenerateOrder(model);
    if (res.statusCode === 'Success') {
      toast.success(res.message);
      trackPromise(getPerformOrderDetailsForMainOrder());
    } else {
      toast.error(res.message);
    }
  }

  async function getPerformOrderDetailsForMainOrder() {
    const res = await services.GetPerformOrderDetailsForMainOrder(date.toISOString());
    var ress1 = res.performOrder.find((x) => x.statusID == 1);
    var ress2 = res.performOrder.find((x) => x.statusID == 2);
    if (ress1 != undefined && ress2 == undefined) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
    if (ress2 != undefined) {
      setChecked(true);
    } else {
      setChecked(false);
    }
    setIsDisabled2(res.performOrder);
  }

  async function generateMainOrder() {
    setIsLoading(true);

    let newOutletOrder = _.cloneDeep(outletOrderDetailsOne);

    var res = await services.GetAllConfigarationValues(
      formik.values.groupID,
      formik.values.operationEntityID
    );
    var ress = await services.GetApprovedProductPrice(date.toISOString());
    let productPrice = _.cloneDeep(ress);
    var productPriceResult = approvedProductPriceSort(productPrice);
    let model = {
      date: date.toISOString(),
      productPrice: productPriceResult,
      outletOrder: [],
      newOutletOrder: newOutletOrder
    };
    var res = await services.SaveGenerateOrder(model);
    if (res.statusCode === 'Success') {
      trackPromise(finalMainOrder());
    } else {
      toast.error(res.message);
      setIsLoading(false);
      setIsDisabled(true);
    }
  }

  async function finalMainOrder() {
    const ress = await services.GetPerformOrderDetailsForMainOrder(date.toISOString());
    let performOrderList = _.cloneDeep(ress.performOrder);
    performOrderList.forEach((y) => {
      y.createdBy = parseInt(TokenDecoder.getUserIDFromToken());
    });
    let availableQuntities = _.cloneDeep(ress.available);
    var result = availableProductPriceSort(availableQuntities);
    let model = {
      performOrderList: performOrderList,
      availableList: result
    };
    var res = await services.UpdatePerformOrder(model);
    if (res.statusCode === 'Success') {
      toast.success(res.message);
      trackPromise(getPerformOrderDetailsForMainOrder());
    } else {
      toast.error(res.message);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2500);
  }

  function orderAndSumBy(arr, orderBy, orderBySecondary, sumBy) {
    return arr
      .map((item) => {
        item.total = arr
          .filter((i) => i[orderBy] === item[orderBy])
          .reduce((acc, o) => acc + o[sumBy], 0);
        item.percentage = parseFloat(item.quantity / item.total);
        item.createdBy = parseInt(TokenDecoder.getUserIDFromToken());
        item.orderDate = date.toISOString();
        item.margeModel = [];
        return item;
      })
      .sort((a, b) => {
        if (a[orderBy] === b[orderBy]) {
          return a[orderBySecondary] + b[orderBySecondary];
        }
        return a[orderBy] - b[orderBy];
      });
  }

  function approvedProductPriceSort(DataList) {
    let finalArray = [];
    for (const defaultElement of DataList) {
      const dd = orderAndSumBy(defaultElement.priceModel, 'realizedPrice', 'quantity', 'quantity');

      let finalModel = {
        productCode: defaultElement.productCode,
        productName: defaultElement.productName,
        isGap: defaultElement.isGap,
        childProductCode: defaultElement.childProductCode,
        priceModel: dd
      };
      finalArray.push(finalModel);
    }
    return finalArray;
  }

  function availableListSum(arr, orderBy, sumBy) {
    return arr.map((item) => {
      item.total = arr
        .filter((i) => i[orderBy] === item[orderBy])
        .reduce((acc, o) => acc + o[sumBy], 0);
      item.percentage = parseFloat(item.quantity / item.total);
      item.createdBy = parseInt(TokenDecoder.getUserIDFromToken());
      return item;
    });
  }

  function availableProductPriceSort(DataList) {
    let finalArray = [];
    for (const defaultElement of DataList) {
      const dd = availableListSum(defaultElement.available, 'cropID', 'quantity');

      let finalModel = {
        operationEntityID: defaultElement.operationEntityID,
        availableModel: dd
      };
      finalArray.push(finalModel);
    }
    return finalArray;
  }

  function getSelectedDropdownValuesForReport() {
    let groupData = group.find((x) => x.groupID == formik.values.groupID);
    setSelectedSearchValues({
      ...selectedSearchValues,
      date: formik.values.date,
      groupID: groupData.groupName
    });
  }

  async function createFile() {
    var file = await createDataForExcel(tableData);
    var settings = {
      sheetName: 'Customer Orders',
      fileName: 'Outlet Order Allocation',
      writeOptions: {}
    };
    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });
    let dataA = [
      {
        sheet: 'Outlet Order Allocation',
        columns: tempcsvHeaders,
        content: file
      }
    ];
    xlsx(dataA, settings);
  }

  async function createDataForExcel(array) {
    var res = [];

    const arrayNew = array.map((obj) => ({
      ...obj,
      shortSupplyAmount:
        obj.quantity - obj.fulfilledQuantity < 0
          ? '-'
          : (obj.quantity - obj.fulfilledQuantity).toFixed(2)
    }));
    if (arrayNew != null) {
      arrayNew.map((x) => {
        var vr = {
          SKU: x.productCode,
          'Crop Name': x.proName,
          Quantity: x.quantity.toFixed(2),
          'Fullfilled Quantity': x.fulfilledQuantity.toFixed(2),
          'Short Supply': x.shortSupplyAmount,
          'Measuring Unit': x.measuringUnitName
        };
        res.push(vr);
      });

      res.push({});
      res.push({});

      var vr1 = {
        SKU: 'Group: ' + selectedSearchValues.groupID,
        'Crop Name': 'Date : ' + date.toISOString().split('T')[0]
      };
      res.push(vr1);

      var vr1 = {
        SKU: 'Total Orders: ' + tableData.length,
        'Crop Name':
          'Total Quantity : ' +
          totalValues.totalQtyKG.toFixed(2) +
          '(KG) | ' +
          totalValues.totalQtyUnit.toFixed(2) +
          '(UNIT)',
        Quantity:
          'Total Fulfilled Quantity : ' +
          totalValues.fulfilledSumKg.toFixed(2) +
          '(KG) | ' +
          totalValues.fulfilledSumUnit.toFixed(2) +
          '(UNIT)',
        'Fullfilled Quantity':
          'Total Remaining Quantity : ' +
          totalValues.remainingKG.toFixed(2) +
          '(KG) | ' +
          totalValues.remainingUnit.toFixed(2) +
          '(UNIT)'
      };
      res.push(vr1);
    }
    return res;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setOutletData({
      ...outletData,
      productCode: value
    });
  }

  async function handleSearch(data) {
    if (tableData == null || tableData.length == 0) {
      setTableData(tableData1);
    }

    const Default = tableData.filter((x) => {
      const code = x.productCode ? x.productCode.toLowerCase() : '';
      const name = x.proName ? x.proName.toLowerCase() : '';
      return code.includes(data.toLowerCase()) || name.includes(data.toLowerCase());
    });

    if (!data) {
      setTableData([]);
      return;
    }

    setTableData(Default);
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <>
      <LoadingComponent />
      <Page title="View Customer Orders |  FAPS">
        <Container>
          <CommonPageHeader
            path={'/createCropForcast'}
            btname="Add"
            pageName="View Customer Orders"
            leftButtonHidden={true}
          />

          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: true
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Group
                    </MenuItem>
                    {group.map((option) =>
                      option.isActive == true ? (
                        <MenuItem key={option.groupID} value={option.groupID}>
                          {option.groupName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Select Date *"
                      value={date}
                      onChange={(newValue) => {
                        setDate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          size="small"
                          {...getFieldProps('date')}
                          error={Boolean(touched.date && errors.date)}
                          helperText={touched.date && errors.date}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button type="submit" color="secondary" variant="outlined">
                      Search
                    </Button>
                  </Stack>
                </Stack>
              </Stack>
              <br />
            </Form>
          </FormikProvider>
          <br />
          {tableData.length != 0 ? (
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <Grid item md={12} xs={12} style={{ border: '2px solid green', borderRadius: 50 }}>
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Total Orders : ' + tableData.length}
                    </Typography>
                  </center>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                  style={{ border: '2px solid green', borderRadius: 50, marginTop: '10px' }}
                >
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Total Fulfilled Quantity : ' +
                        totalValues.fulfilledSumKg.toFixed(3) +
                        ' (KG) | ' +
                        totalValues.fulfilledSumUnit.toFixed(3) +
                        ' (UNIT)'}
                    </Typography>
                  </center>
                </Grid>
              </Grid>
              <Grid item md={6} xs={12}>
                <Grid item md={12} xs={12} style={{ border: '2px solid green', borderRadius: 50 }}>
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Total Quantity : ' +
                        totalValues.totalQtyKG.toFixed(3) +
                        ' (KG) | ' +
                        totalValues.totalQtyUnit.toFixed(3) +
                        ' (UNIT)'}
                    </Typography>
                  </center>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                  style={{ border: '2px solid green', borderRadius: 50, marginTop: '10px' }}
                >
                  <center>
                    <Typography color={'green'} variant="h7">
                      {'Remaining Quantity : ' +
                        totalValues.remainingKG.toFixed(3) +
                        ' (KG) | ' +
                        totalValues.remainingUnit.toFixed(3) +
                        ' (UNIT)'}
                    </Typography>
                  </center>
                </Grid>
              </Grid>
            </Grid>
          ) : null}
          <br />
          {tableData.length != 0 ? (
            <>
              <br />
              <Card>
                <CustomTable tableData={tableData} />
              </Card>
              <br />
              <Divider variant="middle" />
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleChecked}
                      color="secondary"
                      disabled={isDisabled}
                    />
                  }
                  label="Is Main Order"
                />
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="right">
                <Button
                  color="primary"
                  id="btnRecord"
                  type="submit"
                  variant="contained"
                  className={classes.colorRecord}
                  onClick={() => createFile()}
                >
                  EXCEL
                </Button>
                <ReactToPrint
                  documentTitle={'Order Allocation Details Report'}
                  trigger={() => (
                    <Button
                      color="primary"
                      id="btnRecord"
                      type="submit"
                      variant="contained"
                      style={{ backgroundColor: 'red' }}
                      onClick={() => getSelectedDropdownValuesForReport()}
                    >
                      PDF
                    </Button>
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePDF
                    ref={componentRef}
                    tableData={tableData}
                    searchData={selectedSearchValues}
                    date={date}
                    totalValues={totalValues}
                  />
                </div>
                {checked == false ? (
                  <Button
                    type="button"
                    color="secondary"
                    variant="outlined"
                    onClick={() => trackPromise(generatePerformOrder())}
                  >
                    Generate Perform Order
                  </Button>
                ) : (
                  <LoadingButton
                    type="button"
                    color="secondary"
                    disabled={isDisabled}
                    loading={isLoading}
                    variant="outlined"
                    onClick={() => trackPromise(generateMainOrder())}
                  >
                    {'Generate Main Order'}
                  </LoadingButton>
                )}
              </Stack>
            </>
          ) : (
            <SearchNotFound searchQuery="View Customer Orders" />
          )}
        </Container>
      </Page>
    </>
  );
}
